import { useState } from "react";
import { MenuItem, Stack, Box, Chip } from "@mui/material";
import { alpha } from "@mui/material/styles";
import MenuPopover from "src/components/MenuPopover";
import { IconButtonAnimate } from "src/components/animate";
import useCurrencyCurrent from "src/contexts/CurrencyContext";

export default function CurrencyPopover() {
  const { allCurrency, currentCurrency, onChangeCurrency } =
    useCurrencyCurrent();

  const [open, setOpen] = useState(null);

  const handleOpen = (event) => setOpen(event.currentTarget);
  const handleClose = () => setOpen(null);

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpen}
        sx={{
          px: 1,
          borderRadius: 1.5,
          borderWidth: 1,
          borderStyle: "solid",
          borderColor: "divider",
          bgcolor: (theme) => alpha(theme.palette.background.paper, 0.2),
          backdropFilter: "blur(18px)",
          "&:hover": {
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
          },
          ...(open && {
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
            borderColor: "primary.main",
          }),
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <Box
            component="span"
            aria-label={currentCurrency.label}
            sx={{ fontSize: 20, lineHeight: 1 }}
          >
            {currentCurrency.icon}
          </Box>

          <Chip
            size="small"
            label={currentCurrency.value}
            variant="outlined"
            sx={{
              height: 22,
              fontWeight: 700,
              borderRadius: 1.5,
            }}
          />
        </Stack>
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          mt: 1.5,
          ml: 0.75,
          width: 130,
          "& .MuiMenuItem-root": {
            px: 1,
            py: 0.75,
            typography: "body2",
            borderRadius: 1,
          },
        }}
      >
        <Stack spacing={0.5}>
          {allCurrency.map((opt) => (
            <MenuItem
              key={opt.value}
              selected={opt.value === currentCurrency.value}
              onClick={() => {
                onChangeCurrency(opt.value);
                handleClose();
                window.location.reload();
              }}
            >
              <Box
                component="span"
                sx={{ fontSize: 20, mr: 1, lineHeight: 1 }}
              >
                {opt.icon}
              </Box>

              <Chip
                size="small"
                label={opt.value}
                sx={{
                  height: 22,
                  fontWeight: 700,
                  borderRadius: 1.5,
                }}
              />
            </MenuItem>
          ))}
        </Stack>
      </MenuPopover>
    </>
  );
}
